import api from './axios';
import { Course } from './courses';

export interface Teacher {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    specialization?: string;
    courses: Course[];
    createdAt: Date;
    updatedAt: Date;
}

export interface CreateTeacherData {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    specialization?: string;
    courses?: string[];
}

export interface UpdateTeacherData extends Partial<CreateTeacherData> { }

export const getTeachers = async (): Promise<Teacher[]> => {
    const response = await api.get('/teacher');
    return response.data.map((teacher: any) => ({
        ...teacher,
        createdAt: new Date(teacher.createdAt),
        updatedAt: new Date(teacher.updatedAt),
    }));
};

export const getTeacherById = async (id: string): Promise<Teacher> => {
    const response = await api.get(`/teacher/${id}`);
    return {
        ...response.data,
        createdAt: new Date(response.data.createdAt),
        updatedAt: new Date(response.data.updatedAt),
    };
};

export const createTeacher = async (data: CreateTeacherData): Promise<Teacher> => {
    const response = await api.post('/teacher', data);
    return {
        ...response.data,
        createdAt: new Date(response.data.createdAt),
        updatedAt: new Date(response.data.updatedAt),
    };
};

export const updateTeacher = async (id: string, data: UpdateTeacherData): Promise<Teacher> => {
    const response = await api.patch(`/teacher/${id}`, data);
    return {
        ...response.data,
        createdAt: new Date(response.data.createdAt),
        updatedAt: new Date(response.data.updatedAt),
    };
};

export const deleteTeacher = async (id: string): Promise<void> => {
    await api.delete(`/teacher/${id}`);
};
